import { render } from "./PVDataTableAbgabe.vue?vue&type=template&id=3135319c"
import script from "./PVDataTableAbgabe.vue?vue&type=script&lang=js"
export * from "./PVDataTableAbgabe.vue?vue&type=script&lang=js"

import "./PVDataTableAbgabe.vue?vue&type=style&index=0&id=3135319c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__